export const getUserId = appState => {
  const {
    view
  } = appState;
  const presentationUserId = view.presentation.presentation && view.presentation.presentation.userId;
  const sharedLinkUserId = view.presentation.sharedLink && view.presentation.sharedLink.userId;
  return presentationUserId || sharedLinkUserId || null;
};